import {Link} from 'react-router-dom'
import {IVoucherList} from './_model'
import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  handleSelect: (selectType: string, id: number) => void
  voucher: IVoucherList
}

const VoucherActionCell = ({handleSelect, voucher}: Props) => {
  return (
    <div className='text-end'>
      <Link
        to={`preview/${voucher.id}`}
        className='btn btn-icon btn-transparent btn-active-color-primary btn-sm me-1'
      >
        <KTIcon iconName='eye' className='fs-2x text-gray-800' />
      </Link>
    </div>
  )
}

export default VoucherActionCell
